export default __webpack_public_path__ + "static/media/campus.29fbb700.png";